import {
  SIGNIN,
  AUTHENTICATED,
  SIGNOUT,
  GETUSER,
  SETUSER,
  SIGNOUT_SUCCESS,
  SHOW_AUTH_MESSAGE,
  HIDE_AUTH_MESSAGE,
  SIGNUP,
  SIGNUP_SUCCESS,
  SHOW_LOADING,
  HIDE_LOADING,
  SIGNIN_WITH_GOOGLE,
  SIGNIN_WITH_GOOGLE_AUTHENTICATED,
  SIGNIN_WITH_FACEBOOK,
  SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
  SETREDIRECT,
  SETLOGO,
  SETLOGOACTIVE,
  SETLOGOLINK,
  IS_COMPANY_PAGE,
  SCROLL_TO_LIST,
  COMPANY_SLUG,
  JOB_LIST_PAGE_NUMBER,
	JOB_LIST_PER_PAGE
} from '../constants/Auth';

export const signIn = (user) => {
  return {
    type: SIGNIN,
    payload: user
  }
};
export const getProfile = () => {
  return {
    type: GETUSER
  }
}
export const setLogo=(data)=>{
  return {
   type:SETLOGO,
   payload:data
  }
}
export const setLogoActive=(data)=>{
  return {
    type:SETLOGOACTIVE,
    payload:data
  }
}

export const setLogoLink=(data)=>{
  return {
    type:SETLOGOLINK,
    payload:data
  }
}

export const setProfile = (data) => {
  return {
    type: SETUSER,
    data
  }
}

export const authenticated = (data) => {
  return {
    type: AUTHENTICATED,
    data
  }
};

export const signOut = () => {
  
  return {
    type: SIGNOUT
  };
};

export const signOutSuccess = () => {
  return {
    type: SIGNOUT_SUCCESS,
  }
};

export const signUp = (user) => {
  return {
    type: SIGNUP,
    payload: user
  };
};
export const setRedirect=(path)=>{
  return {
    type: SETREDIRECT,
    payload:path
  }
}

export const signUpSuccess = (token) => {
  return {
    type: SIGNUP_SUCCESS,
    token
  };
};

export const signInWithGoogle = () => {
  return {
    type: SIGNIN_WITH_GOOGLE
  };
};

export const signInWithGoogleAuthenticated = (token) => {
  return {
    type: SIGNIN_WITH_GOOGLE_AUTHENTICATED,
    token
  };
};

export const signInWithFacebook = () => {
  return {
    type: SIGNIN_WITH_FACEBOOK
  };
};

export const signInWithFacebookAuthenticated = (token) => {
  return {
    type: SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
    token
  };
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_AUTH_MESSAGE,
    message
  };
};

export const hideAuthMessage = () => {
  return {
    type: HIDE_AUTH_MESSAGE,
  };
};

export const showLoading = () => {
  return {
    type: SHOW_LOADING,
  };
};

export const hideLoading = () => {
  return {
    type: HIDE_LOADING,
  };
};

export function toggleHeader(isCompanyPage) {
  return {
      type: IS_COMPANY_PAGE,
      isCompanyPage
  }
}

export function setListOffset(listPosition) {
  return {
    type: SCROLL_TO_LIST,
    listPosition
  }
}
export function setCompanySlug(companySlug) {
  return {
    type: COMPANY_SLUG,
    companySlug
  }
}

export const jobListPageNumber = (page) => {
  return {
    type: JOB_LIST_PAGE_NUMBER,
    jobListPage:page
  };
};

export const jobListPerPage = (perPage) => {
  return {
    type: JOB_LIST_PER_PAGE,
    jobListPerPage:perPage
  }
}